import { Icon } from 'antd';
import * as React from 'react';

const ContainerSvg = ({
    color='#1890FF'
}) => (
  <svg width="30" height="13" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" rx="3" ry="3" width="30" height="13" fill="transparent"/>
    <line x1="3" x2="3" y1="2" y2="11"/>
    <line x1="6" x2="6" y1="2" y2="11"/>
    <line x1="9" x2="9" y1="2" y2="11"/>
    <line x1="12" x2="12" y1="2" y2="11"/>
    <line x1="15" x2="15" y1="2" y2="11"/>
    <line x1="18" x2="18" y1="2" y2="11"/>
    <line x1="21" x2="21" y1="2" y2="11"/>
    <line x1="24" x2="24" y1="2" y2="11"/>
    <line x1="27" x2="27" y1="2" y2="11"/>
  </svg>
);

const ContainerIcon = props => (
  <Icon component={(innerProps) => {
    return ContainerSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);

export default ContainerIcon;
